import React from "react";

import './portfolio.css';

import biodex from '../../assets/biodex.jpg';
import trt from '../../assets/trt.jpg';
import maxims from '../../assets/maxims.jpg';
import carfelli from '../../assets/carfelli.jpg';
import mary_angel from '../../assets/mary-angel.jpg'
// import grade from '../../assets/grade.jpg';
import tomaso from '../../assets/tomaso.png';
import grade2 from '../../assets/grade2.png';
 

const Portfolio = () => {
    const portfolioList = [
        {
            title: 'Grade',
            image: grade2,
            link: 'https://www.figma.com/design/hkA5BO4BalTktvDNSQm0Zo/Grade-Agency?node-id=4005-951&t=IZIubBOk37LsfoLd-1'
        },
        {
            title: 'Tamaso',
            image: tomaso,
            link: 'https://www.figma.com/design/N8kF2GYTACjDLrGNuEkqgE/TOMASO?node-id=19-265&t=TWRedS11o10OeONF-1'
        },
        {
            title: 'Biodex',
            image: biodex,
            link: 'https://www.figma.com/design/yO65fHXiA2xnK18EHoZrpD/Biodex?node-id=0-1&t=svf3URKmQ2TphhQj-1'
        },
        {
            title: 'Mary Angel',
            image: mary_angel,
            link: 'https://www.figma.com/design/aLrXmlU7qr0EnGftctmi9y/Mary-Angel?node-id=156-56&t=VuTlLm3CMlK1o9SB-1'
        },
        {
            title: 'СARFELLI',
            image: carfelli,
            link: 'https://www.figma.com/design/kpQZUEYgs2WD8vrH3YmNVd/%D0%A1ARFELLI?node-id=531-5284&t=nZ6s4SxFvj552XTu-1'
        },
        {
            title: 'Maxims wedding',
            image: maxims,
            link: 'https://www.figma.com/design/Pgn36m9cYAzMkSKU7W2ema/Maxims-wedding?node-id=0-1&t=fgCK5FMZR4nHZc78-1'
        },
        // {
        //     title: 'Grade',
        //     image: grade,
        //     link: 'https://www.figma.com/design/TaDSFNMZsbd2lKgGRRFJcS/Grade-Agency?node-id=0-1&t=ZanZu3SCRuLSlgiL-1'
        // },
        {
            title: 'TRT EXPRESS',
            image: trt,
            link: 'https://www.figma.com/design/gjcaPuxj4dUK4czk6t7ZVv/TRT-EXPRESS?node-id=498-2798&t=h9lMNyNkr1qmRrjd-1'
        },
    ]


    return (
        <section className="portfolio section" id="portfolio">
            <h2 className='section__title'>Portfolio</h2>
            <span className="section__subtitle">Most recent work</span>
            <div className="grid container portfolio__container">
                <ul className="portfolio__list">    
                    {portfolioList.map((item, key ) => (
                        <li className='portfolio__item' key={key + 1}>
                            <img src={item.image} alt=""/>
                            <div className='portfolio__item-info'>
                                <h3 className="portfolio__title">{item.title}</h3>
                                    <a href={item.link} className="portfolio__button" target='_blank' rel="noreferrer">View More  <i className="uil-arrow-right portfolio__button-icon uil"></i></a>
                               
                            </div>
                        </li>
                    ))}
                </ul>
            </div>
        </section>
    )
}

export default Portfolio;